require("../sass/style.scss");

require("../fonts/fontello/css/fontello.css");


require("./vendor/bootstrap-transition");
require("./vendor/bootstrap-collapse");
require("./vendor/TweenMax.min");
require("./vendor/li-marquee");
require("./vendor/header");
require("./vendor/parallax_content");
require("./vendor/parallaxBackground.js");
require("./vendor/vimeo.es6");
require("./vendor/slick.min");



(function ($) {
    $(".tabs").length > 0 && require("./template_parts/section_tabs.es6");
    $(".testimonials").length > 0 && require("./template_parts/section_testimonials.es6");
    $(".filter-news").length > 0 && require("./template_parts/section_filter-news.es6");
    $(".resources").length > 0 && require("./template_parts/section_resources.es6");
    $(".more-resources").length > 0 && require("./template_parts/section_more_resources.es6");
    $(".our-team").length > 0 && require("./template_parts/section_our_team.es6");
    $(".glossary").length > 0 && require("./template_parts/section_glossary.es6");
    $(".section-vital-conditions").length > 0 && require("./template_parts/page_vital_conditions.es6");
    $(".podcast-episodes").length > 0 && require("./custom/switch-podcasts.es6");
    $(".thriving-together-theater-page").length > 0 && require("./custom/page_our_work_thriving_together_theater.es6");
    $(".workbook-area .panel .header").length > 0 && require("./custom/financing-accordion.es6");
    $(".video-inner").length > 0 && require("./custom/youtube.es6");
    $(".rethinkers-slider-stories").length > 0 && require("./template_parts/rethinkers-slider-stories.es6");
    $(".rethinkers-slider-share").length > 0 && require("./template_parts/rethinkers-slider-share.es6");
    $(".section_tax_banner").length > 0 && require("./template_parts/section_tax_banner.es6");
    $(".rethinkers-slider").length > 0 && require("./template_parts/section_rethink_resources.es6");
    $(".resources-overview").length > 0 && require("./template_parts/section_resources_overview.es6");
    $(".commentary-from-president").length > 0 && require("./template_parts/section_commentary_from_president.es6");
    $(".graphics-hover").length > 0 && require("./template_parts/content_with_graph.es6");

    require("./custom/clip_carousel.es6");
    require("./custom/coming-soon.es6");
})(jQuery);
